// Which host is which. Pure and runtime-agnostic (takes the hostname as a plain string, never
// touches window/self/navigator/location), so the identical checks are safe to import from the
// browser (register.ts, Login.tsx), the service worker (sw.ts) AND the Worker (preview gate).

// Production is the custom domain, plus the same worker's workers.dev address. The browser
// treats everything else as non-production: it refuses to install a service worker (it would
// pin a stale precached shell) and shows the one-tap preview sign-in. Exact matches, not
// endsWith, so no preview host can pass as production.
export const PRODUCTION_HOST = "pointz.fyi";
const PRODUCTION_HOSTS: readonly string[] = [PRODUCTION_HOST, "pointz.anthony-langham.workers.dev"];

export function isProductionHost(hostname: string): boolean {
  return PRODUCTION_HOSTS.includes(hostname);
}

const PREVIEW_HOST_RE = /^pointz-preview(-pr-\d+)?\.anthony-langham\.workers\.dev$/;

/**
 * The hosts where the Worker may mint a session with no code: local dev and the preview
 * workers. An allow-list rather than "not production", so a typo in APP_ORIGIN or a new
 * deployment fails closed and the shortcut stays off.
 */
export function isPreviewHost(hostname: string): boolean {
  return hostname === "localhost" || hostname === "127.0.0.1" || PREVIEW_HOST_RE.test(hostname);
}
